import React from 'react';
import { Card, CardContent, Container, Stack } from '@mui/material';
import { PlayerHeader } from './PlayerHeader';
import { useT } from '../localization/LocalizationProvider';

export function PlayerCardLayout({ children, header }) {
  const t = useT();
  const resolvedHeader = {
    appName: header?.appName || t('Common.AppName'),
    quizTitle: header?.quizTitle || t('Common.AppName'),
    showLogo: header?.showLogo ?? false,
    logoUrl: header?.logoUrl || null
  };

  return (
    <Container maxWidth="md">
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <PlayerHeader
              appName={resolvedHeader.appName}
              quizTitle={resolvedHeader.quizTitle}
              showLogo={resolvedHeader.showLogo}
              logoUrl={resolvedHeader.logoUrl}
            />
            {children}
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}
